import React, { FC } from 'react';

import PropTypes from 'prop-types';

import { Flex, Box, Text } from '@adsk/alloy-react-box';
import Divider from '@adsk/alloy-react-divider';
import { InfoPopover } from '@adsk/alloy-react-tooltip';

type ConfigurationItemProps = {
  title: string;
  collapsed?: boolean;
  tooltipTitle?: string;
  tooltipDescription?: string;
  divider?: boolean;
};

/**
 * Template Configuration side navigation item footer
 */
const LocalSideNavigationHeader: FC<ConfigurationItemProps> = (props) => (
  <>
    {props.divider && (
      <Divider
        data-testid="LocalSideNavigationHeader.Divider"
        style={{
          width: 'auto',
          margin: '12px 16px 0 16px',
        }}
      />
    )}
    {!props.collapsed && (
      <Flex
        color="charcoal800"
        alignItems="center"
        fontWeight="bold"
        margin="16px 14px 12px"
        style={{
          textTransform: 'uppercase',
        }}
      >
        <Text
          fontWeight="bold"
          fontSize={14}
          data-testid="LocalSideNavigationHeader.Title"
        >
          {props.title}
        </Text>
        {props.tooltipTitle && props.tooltipDescription && (
          <InfoPopover
            data-testid="LocalSideNavigationHeader.Tooltip"
            message={
              <div style={{ whiteSpace: 'normal' }}>
                <Box mb={4}>
                  <Text fontWeight="bold">{props.tooltipTitle}</Text>
                </Box>
                {props.tooltipDescription}
              </div>
            }
            placement={InfoPopover.PLACEMENTS.LEFT}
            size={14}
            style={{ lineHeight: 0, padding: '0 10px' }}
          />
        )}
      </Flex>
    )}
  </>
);

LocalSideNavigationHeader.propTypes = {
  collapsed: PropTypes.bool,
};

export default LocalSideNavigationHeader;
